import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import LeadBasicInfoComponent from './lead-basic-info.component';
import AddLeadComponent from './add-lead.component';

export const LeadComponent = ({ distances, weights, handleFormSubmit, dropLocations, setDropLocation, pickupLocations, setPickupLocation, selectedLead, handleInnerFormChange, id, leadDetails, getCategoryName, back }: any) => {
  const tabItems = [
    {
      id: 1,
      title: 'Lead Information',
      component: <AddLeadComponent
        handleInnerFormChange={handleInnerFormChange}
        selectedLead={selectedLead}
        setPickupLocation={setPickupLocation}
        pickupLocations={pickupLocations}
        setDropLocation={setDropLocation}
        dropLocations={dropLocations}
        weights={weights}
        distances={distances}
      />,
      isVisible: id === String(0) ? true : false,
    },
    {
      id: 2,
      title: 'Lead Information',
      component: <LeadBasicInfoComponent
        leadDetails={leadDetails}
        getCategoryName={getCategoryName}
      />,
      isVisible: id > 0 ? true : false
    },

  ]

  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-auto pb-20">


      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end h-20'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}
          disabled={id > 0 ? true : false}
          type="submit"
        >
          Save
        </button>
      </div>
    </div>
  )
}
export default LeadComponent;
